import { http } from './client';

export interface CloseoutEntry {
  id: string; kind: 'expense' | 'credit'; description: string; amount: number; reference: string;
}
export interface CloseoutInputs {
  payrollActual: number | null; payrollReference: string; expensesReviewed: boolean;
  entries: CloseoutEntry[]; note: string;
}
export interface CloseoutCalculation {
  revenue: number; revenueSource: 'invoice' | 'estimate' | 'deposits' | 'none';
  payrollQuoted: number; payrollActual: number | null; costBasis: 'actual' | 'quoted';
  expenses: number; credits: number; totalCosts: number;
  resultBeforeCommissions: number | null; marginBeforeCommissions: number | null;
  status: 'provisional' | 'costs_reviewed'; pending: string[];
}
export interface CloseoutReport {
  eventId: string; eventName: string; revision: number; basisVersion: string;
  inputs: CloseoutInputs; calculation: CloseoutCalculation;
  canEdit: boolean; sourceChanged: boolean;
  savedAt: string | null; savedBy: { id: string; name: string } | null;
}
export interface CloseoutRevision {
  revision: number; inputs: CloseoutInputs; savedAt: string; savedBy: { id: string; name: string };
  snapshot: { calculation: CloseoutCalculation };
}
async function request<T>(method: 'GET' | 'POST', url: string, data?: unknown): Promise<T> {
  const { response, error } = await http<{ data: T }>({ method, url: `financial-closeouts/${url}`, data, isToken: true });
  if (error || !response) throw new Error(error?.response?.data?.message || 'Could not load financial closeout.');
  return response.data.data;
}
export const financialCloseout = {
  get: (eventId: string) => request<CloseoutReport>('GET', eventId),
  save: (report: CloseoutReport, inputs: CloseoutInputs) => request<CloseoutReport>('POST', `${report.eventId}/revisions`, {
    revision: report.revision, basisVersion: report.basisVersion, inputs,
  }),
  history: (eventId: string) => request<CloseoutRevision[]>('GET', `${eventId}/history`),
};
